import { useEffect, useRef } from "react";
import { useFormData } from "../context/FormDataContext";

function safeStr(v) {
  return v == null ? "" : String(v).trim();
}

function splitFullName(full) {
  const s = safeStr(full);
  if (!s) return { jmeno: "", prijmeni: "" };
  const parts = s.split(/\s+/).filter(Boolean);
  if (parts.length === 1) return { jmeno: parts[0], prijmeni: "" };
  return { jmeno: parts.slice(0, -1).join(" "), prijmeni: parts[parts.length - 1] };
}

export function useAutoSaveZakazka(enabled = true, debounceMs = 900) {
  const { formData, currentOrderId, knihyApiUlozit, isOpeningOrder, setCurrentOrderId, setIsEditingExisting } = useFormData();
  const tRef = useRef(null);
  const lastRef = useRef("");

  useEffect(() => {
    if (!enabled) return;

    if (isOpeningOrder) return;
    const watched = {
      vyjezdy: formData?.vyjezdy || {},
      vstupniInformace: formData?.vstupniInformace || {},
      zesnulaOsoba: formData?.zesnulaOsoba || {},
      slozkaSablon: formData?.slozkaSablon || "",
      stavZakazky: formData?.stavZakazky || "",
    };

    const hash = JSON.stringify(watched);
      const EMPTY_HASH = JSON.stringify({ vyjezdy:{}, vstupniInformace:{}, zesnulaOsoba:{}, slozkaSablon:"", stavZakazky:"" });
      if (hash === EMPTY_HASH) return; // nic neukládej, je to úplně prázdné
    if (hash === lastRef.current) return;
    lastRef.current = hash;

    if (tRef.current) clearTimeout(tRef.current);

    tRef.current = setTimeout(async () => {
      try {
          let id = currentOrderId;

          // 🔒 Autosave NESMÍ zakládat novou zakázku.
          // Zakázka vzniká jen ručně (createOrder / Nová zakázka / Uložit).
          if (!id) return;



        const v = formData?.vstupniInformace || {};
        const z = formData?.zesnulaOsoba || {};
        const vyj = formData?.vyjezdy || {};

        let prijmeni = safeStr(v.prijmeniZesnuleho) || safeStr(z.prijmeni) || safeStr(v.prijmeni) || "";
        let jmeno = safeStr(v.jmenoZesnuleho) || safeStr(z.jmeno) || safeStr(v.jmeno) || "";

        if ((!jmeno || !prijmeni) && safeStr(vyj.zesnulyJmeno)) {
          const sp = splitFullName(vyj.zesnulyJmeno);
          if (!jmeno) jmeno = sp.jmeno;
          if (!prijmeni) prijmeni = sp.prijmeni;
        }

        const datumUmrti = safeStr(v.datumUmrti) || safeStr(z.datumUmrti) || safeStr(vyj.datumUmrti) || "";

        const title = [prijmeni, jmeno].filter(Boolean).join(" ").trim() || "Rozpracovaná zakázka";

                  const payload = {
            __explicit: true,
            id,
            prijmeni,
            jmeno,
            datumUmrti,

            title,
            nazev: title,
            zesnuly: title,
            zesnulyJmeno: [jmeno, prijmeni].filter(Boolean).join(" ").trim(),

            slozkaSablon: formData?.slozkaSablon || "kremace",
            stavZakazky: formData?.stavZakazky || "rozpracovana",
            formData,
          };

          const out = await knihyApiUlozit(payload);
      } catch {
        // autosave chyby neotravují
      }
    }, debounceMs);

    return () => {
      if (tRef.current) clearTimeout(tRef.current);
    };
  }, [enabled, debounceMs, formData, currentOrderId, knihyApiUlozit, isOpeningOrder]);
}
